import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HK_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#HK_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#EA1A1A"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HK_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HK_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.87 11.575s-5.79-5.163 1.118-8.172c0 0 2.01 2.217.502 4.705-.494.817-.911 1.4-1.225 1.837-.642.898-.849 1.187-.396 1.63zM7.323 7.868c-.397 7.524 6.81 4.654 6.81 4.654-.599.208-.765-.107-1.28-1.082-.252-.476-.587-1.11-1.096-1.917-1.552-2.461-4.434-1.655-4.434-1.655zm10.914 3.96s7.432 2.224 2.448 7.876c0 0-2.76-1.157-2.448-4.05.102-.948.233-1.653.331-2.182.202-1.085.267-1.435-.331-1.645zm-1.953 1.734s1.332 7.642-5.952 5.71c0 0-.198-2.984 2.529-3.999a26.9 26.9 0 012.1-.68c1.06-.304 1.403-.403 1.323-1.031zm9.193-3.287c-4.555-6.002-8.205.844-8.205.844.324-.545.654-.412 1.677 0 .5.2 1.165.468 2.075.756 2.774.877 4.453-1.6 4.453-1.6z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.951 10.342l.422-.268c.927 1.458 2.129 2.175 3.63 2.175v.5c-1.68 0-3.037-.81-4.052-2.407z",
      fill: "#EA1A1A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.75 10.75a.75.75 0 100-1.5.75.75 0 000 1.5zM19.959 15.729a.75.75 0 100-1.5.75.75 0 000 1.5zM13.959 17.729a.75.75 0 100-1.5.75.75 0 000 1.5zM9.959 10.729a.75.75 0 100-1.5.75.75 0 000 1.5zM15.959 7.729a.75.75 0 100-1.5.75.75 0 000 1.5z",
      fill: "#EA1A1A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.635 7.053l.44.238c-.833 1.536-.892 2.952-.187 4.279l-.441.234c-.787-1.48-.721-3.074.188-4.751zM22.014 9.686l-.075.494c-1.955-.296-3.42.117-4.422 1.23l-.371-.335c1.124-1.249 2.757-1.709 4.868-1.389z",
      fill: "#EA1A1A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.351 15.365l-.49.099c-.39-1.94-1.279-3.174-2.668-3.735l.188-.464c1.558.63 2.549 2.007 2.97 4.1zM13.906 17.15l-.26-.427c1.688-1.03 2.544-2.287 2.597-3.784l.5.018c-.06 1.68-1.014 3.081-2.837 4.193z",
      fill: "#EA1A1A"
    }
  )))
);
export {
  t as default
};
